export const fr = {
  common: {
    save: "Enregistrer",
    cancel: "Annuler",
    close: "Fermer",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    update: "Mettre à jour",
    loading: "Chargement",
    error: "Erreur",
    saved: "Enregistré",
    yes: "Oui",
    no: "Non",
    all: "Tout",
    apply: "Appliquer",
    signOut: "Se déconnecter",
    confirm: "Confirmer",
    optionalNotes: "Notes optionnelles",
    confirmDelete: "Confirmer la suppression",
    current: "Actuel",
    ok: "OK",
    warning: "Avertissement",
    success: "Succès",
    back: "Retour",
    copied: "Copié",
    refresh: "Actualiser",
    add: "Ajouter",
    change: "Modifier",
    countryCode: "Indicatif pays",
    none: "Aucun",
  },

  auth: {
    login: "Connexion",
    logout: "Déconnexion",
    register: "Inscription",
    email: "Email",
    phone: "Téléphone",
    password: "Mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    firstName: "Prénom",
    lastName: "Nom",
    accountName: "Nom du compte",
    loginFailed: "Échec de la connexion.",
    signInSubtitle: "Gérez vos appartements, réservations et clients.",
    forgotPassword: "Mot de passe oublié ?",
    forgotPasswordSubtitle:
      "Saisissez votre email et nous vous enverrons les instructions pour réinitialiser votre mot de passe.",
    sendResetLink: "Envoyer le lien de réinitialisation",
    backToLogin: "Retour à la connexion",
    or: "ou",
    loginWithGoogle: "Continuer avec Google",
    loginWithFacebook: "Continuer avec Facebook",
    noAccount: "Vous n'avez pas de compte ?",
    createAccount: "Créer un compte",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    registerSubtitle:
      "Créez votre compte RentPilot et commencez à gérer vos locations.",
    verifyEmailBanner:
      "Veuillez vérifier votre adresse e-mail avant d’utiliser toutes les fonctionnalités de RentPilot.",
    resendVerificationEmail: "Renvoyer l’e-mail",
    iVerified: "J’ai vérifié",
    resetPassword: "Réinitialiser le mot de passe",
    resetPasswordSubtitle:
      "Saisissez un nouveau mot de passe pour votre compte RentPilot.",
    newPassword: "Nouveau mot de passe",
    invalidResetLink:
      "Le lien de réinitialisation du mot de passe est invalide ou incomplet.",
  },

  tabs: {
    calendar: "Calendrier",
    properties: "Propriétés",
    statistics: "Statistiques",
    profile: "Profil",
    team: "Équipe",
    cleaners: "Équipe",
    support: "Support",
    cleaningTasks: "Tâches",
    invoices: "Factures",
    menu: "Menu",
  },

  cleaners: {
    title: "Équipe",
    add: "Ajouter",
    cleaners: "Membres de l'équipe",
    newCleaner: "Nouveau membre de l'équipe",
    createCleaner: "Créer un membre de l'équipe",
    noCleaners: "Aucun membre de l'équipe pour le moment.",
    schedule: "Planning",
    noTasks: "Aucune tâche de nettoyage.",
    assignCleaner: "Assigner un membre de l'équipe",
    cleanedHistory: "Historique des nettoyages",
    noCleanedHistory: "Aucune unité nettoyée pour le moment.",
    failedCreateCleaner: "Impossible de créer le membre de l'équipe.",
    deleteQuestion: "Supprimer {{name}} ?",
    description: "Gérez les membres de l’équipe et leur accès à l’application.",
    teamAccess: "Accès à l’équipe",
    members: "membres",
    addMemberDescription:
      "Ajoutez un responsable, un observateur ou une femme de ménage à votre compte.",
    roleOverview: "Aperçu des rôles",
    managerDescription:
      "Peut gérer les réservations, les biens, les clients, les tâches et l’équipe.",
    viewerDescription: "Peut consulter le calendrier sans gérer les données.",
    cleanerDescription:
      "Peut uniquement voir les tâches de nettoyage assignées.",
  },

  cleaning: {
    myTasks: "Mes tâches",
    today: "Aujourd'hui",
    upcoming: "À venir",
    done: "Terminé",
    noTasksToday: "Aucune tâche pour aujourd'hui.",
    noUpcomingTasks: "Aucune tâche à venir.",
    noDoneTasks: "Aucune tâche terminée.",
    scheduled: "Planifié",
    cleanedAt: "Nettoyé à",
    assignedTo: "Assigné à",
    unassigned: "Non assigné",
    start: "Commencer",
    markCleaned: "Marquer comme nettoyé",
    futureTaskCannotBeCompleted:
      "Cette tâche peut être terminée le jour prévu.",
    status: {
      pending: "En attente",
      in_progress: "En cours",
      done: "Terminé",
      cancelled: "Annulé",
    },
    description:
      "Voir les tâches du jour, les nettoyages à venir et l’historique des nettoyages terminés.",
  },

  calendar: {
    unit: "Unité",
    noUnits: "Aucune unité",
    filters: "Filtres",
    startDate: "Date de début",
    endDate: "Date de fin",
    thisWeek: "Cette semaine",
    twoWeeks: "Deux semaines",
    threeWeeks: "Trois semaines",
    thisMonth: "Ce mois-ci",
    occupied: "Occupé",
    unavailable: "Indisponible",
    rangeOverlaps:
      "La plage de dates sélectionnée chevauche une réservation existante.",
    occupiedCellMessage:
      "Cette unité a déjà une réservation à la date sélectionnée.",
    selectCheckIn: "Sélectionner l'arrivée",
    selectCheckOut: "Sélectionner le départ",
    clear: "Effacer",
    multi: "Multi",
    single: "Simple",
    next7Days: "7 prochains jours",
    next14Days: "14 prochains jours",
    selectedStart: "Début sélectionné",
    tapCheckoutDate: "Appuyez sur la date de départ pour créer une réservation",
    subtitle: "Aperçu des unités, réservations, paiements et nettoyages.",
    available: "Disponible",
    addObjects: "Ajouter des objets",
    addObjectsDescription:
      "Créez votre premier établissement et votre première unité pour gérer les réservations.",
    month: "Mois",
    next: "Suivant",
    allUnits: "Tous les appartements",
    checkInAfter: "Arrivée après 14:00",
    checkOutBefore: "Départ avant 10:00",
    cleaning: "Nettoyage",
    private: "Privé",
    closed: "Fermé",
    today: "Aujourd’hui",
    fullYear: "Année complète",
    availableDates: "Dates disponibles",
    availableDatesByUnit: "Dates disponibles par appartement",
    shown: "affichés",
    terms: "créneaux",
    noFreePeriods: "Aucune date disponible",
  },

  booking: {
    newBooking: "Nouvelle réservation",
    bookingDetails: "Détails de la réservation",
    guestFirstName: "Prénom du client",
    guestLastName: "Nom du client",
    guest: "Client",
    phone: "Téléphone",
    email: "Email",
    unit: "Unité",
    checkIn: "Arrivée",
    checkOut: "Départ",
    nights: "Nuits",
    pricePerNight: "Prix par nuit",
    total: "Total",
    status: "Statut",
    payment: "Paiement",
    paymentStatus: "Statut du paiement",
    unpaid: "Non payé",
    deposit: "Acompte",
    paid: "Payé",
    reserved: "Réservé",
    checkedIn: "Arrivé",
    checkedOut: "Parti",
    cancelled: "Annulé",
    notes: "Notes",
    createBooking: "Créer la réservation",
    failedCreate: "Impossible de créer la réservation.",
    guestFirstNamePlaceholder: "Jean",
    guestLastNamePlaceholder: "Dupont",
    phonePlaceholder: "+387...",
    emailPlaceholder: "jean@example.com",
    pricePlaceholder: "45",
    arrivingAround: "Arrivée vers 18:00",
    currency: "Devise",
    dateRange: "Dates du séjour",
    selectDates: "Sélectionner les dates",
    selectCheckIn: "Sélectionner la date d'arrivée",
    selectedDateOccupied: "Cette date est déjà occupée.",
    selectedRangeOverlaps:
      "Les dates sélectionnées chevauchent une réservation existante.",
    numberOfGuests: "Voyageurs",
    checkoutAfterCheckin: "Le départ doit être après l’arrivée.",
    contactGuest: "Contacter le client",
    invoice: "Facture",
    whatsapp: "WhatsApp",
    missingEmail: "Ce client n’a pas d’adresse e-mail.",
    missingPhone: "Ce client n’a pas de numéro de téléphone.",
    noContactInfo: "Ce client n’a ni adresse e-mail ni numéro de téléphone.",
    confirmSendInvoice: "Envoyer la facture à ce client ?",
    invoiceSent: "Facture envoyée.",
    failedSendInvoice: "Impossible d’envoyer la facture.",
    booking: "Réservation",
    editBooking: "Modifier la réservation",
    saveBooking: "Enregistrer la réservation",
    sendInvoice: "Envoyer la facture",
    cancelBooking: "Annuler la réservation",
    cancelBookingQuestion: "Voulez-vous vraiment annuler cette réservation ?",
    bookingCreated: "Réservation créée.",
    bookingUpdated: "Réservation mise à jour.",
    bookingCancelled: "Réservation annulée.",
    failedUpdate: "Impossible de mettre à jour la réservation.",
    failedCancel: "Impossible d’annuler la réservation.",
    unitMissing: "L’unité est manquante.",
    emailUnavailable: "E-mail indisponible.",
    emailSubject: "Informations de réservation",
    emailBody: "Bonjour, voici les détails de votre réservation.",
    whatsappMessage: "Bonjour, voici les détails de votre réservation.",
    missingGuestEmail: "L’e-mail du client est manquant.",
    confirmSendInvoiceMessage:
      "La facture sera envoyée à l’adresse e-mail du client.",
    checked_in: "Arrivé",
    checked_out: "Parti",
  },

  bookingMessages: {
    title: "Message WhatsApp",
    templateOne:
      "Bonjour {{guest}}, votre réservation pour {{unit}} est confirmée du {{checkIn}} au {{checkOut}}.",
    templateTwo:
      "Bonjour {{guest}}, merci pour votre réservation. L’arrivée est le {{checkIn}} et le départ le {{checkOut}}.",
    templateThree:
      "Bonjour {{guest}}, nous avons hâte de vous accueillir à {{unit}}. Vos dates sont {{checkIn}} - {{checkOut}}.",
    templateButton: "Modèle {{number}}",
    customPlaceholder: "Écrire votre message...",
    openWhatsApp: "Ouvrir WhatsApp",
    customMessage: "Message personnalisé",
    invalidPhone: "Numéro de téléphone invalide.",
    missingPhone: "Numéro de téléphone manquant.",
    whatsappUnavailable: "WhatsApp n’est pas disponible.",
  },

  properties: {
    title: "Propriétés",
    newProperty: "Nouvelle propriété",
    createProperty: "Créer une propriété",
    propertyName: "Nom de la propriété",
    address: "Adresse",
    city: "Ville",
    notes: "Notes",
    noUnits: "Aucune unité pour le moment",
    units: "unités",
    newUnit: "Nouvelle unité",
    createUnit: "Créer une unité",
    unitName: "Nom de l'unité",
    type: "Type",
    capacity: "Capacité",
    defaultPricePerNight: "Prix par nuit par défaut",
    noDefaultPrice: "Aucun prix par défaut",
    guests: "clients",
    disable: "Désactiver",
    enable: "Activer",
    deleteProperty: "Supprimer la propriété",
    deletePropertyQuestion:
      "Supprimer {{name}} ? Cela fonctionne uniquement s'il n'y a aucun historique de réservation.",
    deleteUnit: "Supprimer l'unité",
    deleteUnitQuestion:
      "Supprimer cette unité ? Si elle a un historique de réservation, vous pouvez la désactiver à la place.",
    failedCreateProperty: "Impossible de créer la propriété.",
    failedCreateUnit: "Impossible de créer l'unité.",
    apartment: "Appartement",
    room: "Chambre",
    studio: "Studio",
    house: "Maison",
    other: "Autre",
    newPropertyPlaceholder: "Sarajevo Apartments",
    addressPlaceholder: "Rue 1",
    cityPlaceholder: "Sarajevo",
    notesPlaceholder: "Notes optionnelles",
    unitNamePlaceholder: "Appartement A",
    pricePlaceholder: "45",
    capacityPlaceholder: "2",
    pricePerNightShort: "{{price}} / nuit",
    deletePropertySuccess: "Propriété supprimée.",
    deleteUnitSuccess: "Unité supprimée.",
    addUnit: "Ajouter une unité",
    activeUnits: "unités actives",
    inactiveUnits: "unités inactives",
    calendarSync: "Synchronisation du calendrier",
    calendarSyncHelp:
      "Collez ici les liens d’export iCal Airbnb et Booking.com. RentPilot importera ces calendriers et bloquera les dates correspondantes.",
    airbnbIcalLink: "Lien iCal Airbnb",
    bookingIcalLink: "Lien iCal Booking.com",
    rentPilotExportLink: "Lien d’export RentPilot",
    rentPilotExportCalendar: "Calendrier d’export RentPilot",
    rentPilotExportHelp:
      "Copiez ce lien dans Airbnb et Booking.com afin qu’ils puissent bloquer les dates depuis RentPilot.",
    rentPilotExportHelpLong:
      "Collez ce lien dans les paramètres de calendrier externe d’Airbnb ou Booking.com.",
    airbnbConnected: "Airbnb connecté",
    airbnbNotConnected: "Airbnb non connecté",
    bookingConnected: "Booking.com connecté",
    bookingNotConnected: "Booking.com non connecté",
    noExternalCalendarsConnected: "Aucun calendrier externe connecté.",
    copyShareExportLink: "Copier le lien d’export",
    exportLinkMissing:
      "Le lien d’export est manquant. Le backend n’a pas renvoyé calendar_export_url pour cette unité.",
    exportLinkCopied: "Lien d’export copié.",
    editUnit: "Modifier l’unité",
    saveUnit: "Enregistrer l’unité",
    noUnitsDescription:
      "Ajoutez des chambres/appartements afin que les réservations et les tâches de nettoyage puissent être liées à cet établissement.",
    activateUnit: "Activer l’unité",
    deactivateUnit: "Désactiver l’unité",
    failedDeleteProperty: "Impossible de supprimer l’établissement.",
    failedDeleteUnit: "Impossible de supprimer l’unité.",
    failedUpdateUnit: "Impossible de mettre à jour l’unité.",
  },

  statistics: {
    title: "Statistiques",
    revenue: "Revenus",
    bookings: "Réservations",
    nights: "Nuits",
    averageBooking: "Réservation moyenne",
    breakdown: "Répartition",
    noStatistics: "Aucune statistique pour les filtres sélectionnés.",
    groupBy: "Grouper par",
    unit: "Unité",
    property: "Propriété",
    month: "Mois",
    payment: "Paiement",
    sevenDays: "7 jours",
    fourteenDays: "14 jours",
    thirtyDays: "30 jours",
    thisMonth: "Ce mois-ci",
    allProperties: "Toutes les propriétés",
    allUnits: "Toutes les unités",
    byUnit: "Par unité",
    byProperty: "Par propriété",
    byMonth: "Par mois",
    netProfit: "Bénéfice net",
    occupancy: "Occupation",
    profitMargin: "Marge bénéficiaire",
    expenseRatio: "Ratio des dépenses",
    revenueByUnit: "Revenus par unité",
    revenueByApartment: "Revenus par appartement",
    noRevenueForPeriod: "Aucun revenu pour la période sélectionnée.",
    noExpensesForPeriod: "Aucune dépense pour la période sélectionnée.",
    manualVsRecurringExpenses: "Dépenses ponctuelles vs récurrentes",
    cashflow: "Flux de trésorerie",
    latestNetProfit: "Dernier bénéfice net : {{amount}}",
    performanceBreakdown: "Analyse des performances",
    breakdownMeta: "{{bookings}} réservations · {{nights}} nuits",
    margin: "Marge",
    revenueExpensesHint: "{{revenue}} revenus · {{expenses}} dépenses",
    expenses: "Dépenses",
    expensesByCategory: "Dépenses par catégorie",
    filters: "Filtres",
  },

  expenses: {
    expenses: "Dépenses",
    newExpense: "Nouvelle dépense",
    editExpense: "Modifier la dépense",
    newRecurringExpense: "Nouvelle dépense récurrente",
    editRecurringExpense: "Modifier la dépense récurrente",
    manualExpenses: "Dépenses ponctuelles",
    recurringExpenses: "Dépenses récurrentes",
    totalExpenses: "Dépenses totales",
    noExpenses: "Aucune dépense pour le moment.",
    noRecurringExpenses: "Aucune dépense récurrente pour le moment.",
    name: "Nom",
    category: "Catégorie",
    categoryPlaceholder: "Nettoyage, charges, maintenance...",
    amount: "Montant",
    date: "Date",
    frequency: "Fréquence",
    monthly: "Mensuel",
    yearly: "Annuel",
    interval: "Intervalle",
    dayOfMonth: "Jour du mois",
    startDate: "Date de début",
    endDate: "Date de fin",
    active: "Actif",
    inactive: "Inactif",
    noProperty: "Aucune propriété",
    noUnit: "Aucune unité",
    uncategorized: "Sans catégorie",
    expensesByCategory: "Dépenses par catégorie",
    expensesByType: "Dépenses par type",
    expensesByUnit: "Dépenses par unité",
    addExpense: "Ajouter une dépense",
    oneTimeExpense: "Dépense ponctuelle",
    oneTimeExpenseDescription:
      "Utilisez ceci pour un coût unique, comme une réparation, des serviettes ou un achat ponctuel.",
    recurringExpense: "Dépense récurrente",
    recurringExpenseDescription:
      "Utilisez ceci pour les coûts répétés, comme internet, les abonnements ou les fournitures mensuelles.",
  },

  profile: {
    title: "Profil",
    firstName: "Prénom",
    lastName: "Nom",
    phone: "Téléphone",
    saveProfile: "Enregistrer le profil",
    profileUpdated: "Profil mis à jour.",
    updateEmail: "Mettre à jour l'email",
    currentPassword: "Mot de passe actuel",
    emailUpdated: "Email mis à jour.",
    password: "Mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmNewPassword: "Confirmer le nouveau mot de passe",
    updatePassword: "Mettre à jour le mot de passe",
    passwordUpdated: "Mot de passe mis à jour.",
    passwordsDoNotMatch:
      "Le nouveau mot de passe et sa confirmation ne correspondent pas.",
    language: "Langue",
    signOutQuestion: "Êtes-vous sûr de vouloir vous déconnecter ?",
    failedProfileUpdate: "Impossible de mettre à jour le profil.",
    failedEmailUpdate: "Impossible de mettre à jour l'email.",
    failedPasswordUpdate: "Impossible de mettre à jour le mot de passe.",
    email: "Email",
    emailPlaceholder: "email@example.com",
    phonePlaceholder: "+387...",
    firstNamePlaceholder: "Prénom",
    lastNamePlaceholder: "Nom",
    currentPasswordPlaceholder: "Mot de passe actuel",
    newPasswordPlaceholder: "Nouveau mot de passe",
    confirmNewPasswordPlaceholder: "Confirmer le nouveau mot de passe",
    signOut: "Se déconnecter",
    currencySettings: "Devise",
  },

  currency: {
    currency: "Devise",
    currencyUpdated: "Devise mise à jour",
    defaultCurrency: "Devise par défaut",
    bam: "KM",
    eur: "€",
    usd: "$",
    rsd: "RSD",
    failedCurrencyUpdate: "Impossible de mettre à jour la devise.",
  },

  support: {
    title: "Support",
    needSupport: "Besoin d'aide ?",
    description:
      "Contactez-nous si vous avez besoin d'aide avec votre compte, vos réservations, vos propriétés, votre équipe ou votre abonnement.",
    callSupport: "Appeler le support",
    emailSupport: "Contacter le support par email",
  },

  subscription: {
    title: "Abonnement",
    subtitle: "Choisissez l'offre adaptée à votre activité de location.",
    currentPlan: "Offre actuelle",
    freeNotice: "Vous utilisez actuellement l'offre gratuite.",
    perMonth: "/ mois",
    choosePlan: "Choisir l'offre",
    manageBilling: "Gérer la facturation",
    upgradeRequired: "Mise à niveau requise",
    upgradeRequiredMessage:
      "La limite de votre offre actuelle a été atteinte. Veuillez mettre à niveau votre abonnement.",
    accessWarningTitle: "L’accès à RentPilot expire bientôt",

    accessWarningMessage:
      "Votre accès à RentPilot expire le {{date}}. Choisissez ou renouvelez une formule avant cette date pour continuer à créer et modifier des données.",

    customAccessWarningMessage:
      "Votre formule RentPilot personnalisée expire le {{date}}. Contactez l’assistance RentPilot et organisez le paiement avant cette date pour continuer à utiliser l’application.",

    accessExpiredTitle: "L’accès à RentPilot est restreint",

    accessExpiredMessage:
      "Votre abonnement a expiré ou n’a pas été payé. Vous pouvez toujours consulter les données existantes, mais la création et la modification de données sont désactivées jusqu’au paiement.",

    customAccessExpiredMessage:
      "Votre formule RentPilot personnalisée a expiré ou n’a pas été payée. Vous pouvez toujours consulter les données existantes, mais la création et la modification de données sont désactivées. Contactez l’assistance RentPilot pour organiser le paiement et rétablir l’accès.",

    contactAccountOwnerMessage:
      "Contactez le propriétaire du compte afin d’organiser le paiement et de rétablir l’accès complet.",

    viewPlansCta: "Voir les formules",

    contactSupportCta: "Contacter l’assistance",

    noticeCloseCta: "J’ai compris",
    billingPeriod: "période de facturation",
    trialExpiresSoonBanner:
      "Votre période d’essai expire dans {{hours}} heures. Pour continuer à utiliser RentPilot, choisissez une offre dans l’application web.",
    trialExpiresSoonCta: "Choisir une offre",
    billingPeriodDescription:
      "Choisissez le nombre de mois que vous souhaitez payer à l’avance.",
    planColumn: "Forfait",
    limitColumn: "Limite",
    priceColumn: "Prix",
    discountColumn: "Réduction",
    featuresColumn: "Inclus",
    actionColumn: "Action",
    recommended: "Recommandé",
    discountBadge: "{{discount}}% de réduction",
  },

  menu: {
    pricing: "Tarifs",
    pricingDescription:
      "Consultez votre offre actuelle et vos options de facturation.",
    currentPlan: "Offre actuelle",
    pricingComingSoon: "La gestion complète des tarifs sera connectée ici.",
    myAccount: "Mon compte",
    myAccountDescription: "Profil, email et mot de passe.",
    support: "Support",
    supportDescription:
      "Contacter le support ou consulter les informations d'aide.",
    settings: "Paramètres",
    settingsDescription: "Apparence de l'application, langue et devise",
    privacy: "Confidentialité et informations sur l’entreprise",
    privacyDescription:
      "Informations sur l’entreprise, le service client et la protection de la vie privée.",
  },

  settings: {
    appAppearance: "Apparence de l'application",
    fontSize: "Taille de police",
    fontSmall: "Petite",
    fontMedium: "Moyenne",
    fontLarge: "Grande",
    fontVeryLarge: "Très grande",
    bookingColors: "Couleurs des réservations",
    theme: "Thème",
    themeSystem: "Système",
    themeLight: "Clair",
    themeDark: "Sombre",
  },

  roles: {
    role: "Rôle",
    owner: "Propriétaire",
    manager: "Gestionnaire",
    cleaner: "Femme de chambre",
    viewer: "Observateur",
    teamMember: "Membre de l’équipe",
  },

  invoices: {
    title: "Factures envoyées",
    description: "Voir les factures envoyées et l’historique des e-mails.",
    emptyTitle: "Aucune facture pour le moment",
    empty: "Aucune facture n’a encore été envoyée.",
    failedLoad: "Impossible de charger les factures.",
    sentAt: "Envoyé le",
    status: {
      pending: "En attente",
      sent: "Envoyé",
      failed: "Échec",
    },
  },
  accountDeletion: {
    title: "Brisanje računa",
    description:
      "Ovim šaljete zahtjev za trajno brisanje računa. Svi objekti, jedinice, rezervacije, gosti, članovi tima, fakture, zadaci čišćenja, troškovi i postavke povezane s ovim računom bit će obrisani.",
    warning:
      "Brisanje se zakazuje sa sigurnosnim odgodom, ali ovo koristite samo ako ste sigurni.",
    typeDelete: "Upišite DELETE za potvrdu brisanja računa.",
    requestDeletion: "Zatraži brisanje",
    alreadyScheduled: "Brisanje računa je već zakazano za {{date}}.",
    cancelInfo:
      "Zahtjev za brisanje možete otkazati prije zakazanog datuma brisanja.",
    cancelDeletion: "Otkaži zahtjev za brisanje",
    cancelQuestion: "Da li ste sigurni da želite otkazati zahtjev za brisanje?",
    scheduledMessage: "Brisanje računa je zakazano.",
    cancelledMessage: "Zahtjev za brisanje računa je otkazan.",
    failedRequest: "Nije moguće zatražiti brisanje računa.",
    failedCancel: "Nije moguće otkazati brisanje računa.",
  },

  merchant: {
    title: "Informations sur le commerçant",
    description:
      "Informations sur l’entité juridique qui fournit et facture le service RentPilot.",
    legalName: "Nom complet de l’entité juridique",
    address: "Adresse",
    businessActivity: "Activité commerciale",
    activityCode: "Code d’activité",
    registrationNumber: "Numéro d’enregistrement",
    taxNumber: "Numéro fiscal / JIB",
    website: "Site web",
    phone: "Téléphone de contact",
    email: "E-mail de contact",

    customerServiceTitle: "Service client",
    customerServiceDescription:
      "Pour toute information concernant les commandes et les paiements, les réclamations, l’annulation du service ou toute autre demande, vous pouvez nous contacter aux coordonnées ci-dessous.",

    privacyTitle: "Protection de la vie privée",
    privacyDescription:
      "RentPilot collecte uniquement les données nécessaires à la fourniture du service, à la gestion des comptes utilisateurs, au traitement des commandes et des paiements, au support client et au respect des obligations légales. Les données personnelles ne sont pas vendues. Elles sont accessibles uniquement aux personnes autorisées et aux prestataires de services qui en ont besoin pour remplir leurs obligations. Les données de carte sont saisies exclusivement sur la page sécurisée du prestataire de paiement et ne sont ni accessibles ni stockées par le système RentPilot.",
  },
};
